


















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class Maintenance extends Vue
{
    @Prop({required: true}) message: any;

    get json()
    {
        return JSON.parse(this.message);
    }
}
